// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import $ from 'jquery';
import 'plugins/jquery.slick.js';

export default class Webslider extends WebComponent {

	didMount() {
		$(this.element).slick({
			initialSlide: 0,
      dots: false,
      arrows: false,
      infinite: true,
      cssEase: 'linear',
      slidesToShow: 1,
      fade: true,
      adaptiveHeight: true,
      autoplay: true,
      autoplaySpeed: 4000,
      speed: 1200,
      pauseOnHover: true,
		});

		const customNavLinks = $('.js_sliderNav li');
    // update navigation acording to the current slide index
    function updateNavigation() {
      var currentSlideIndex = $('.slick-current').attr("data-slick-index");
      customNavLinks.removeClass('active');
      customNavLinks.eq(currentSlideIndex).addClass('active');
    }

		$('.js_sliderNav .slider__nav-item-button').each(function(index){
			$(this).on('click', function(e){
				e.preventDefault();
				customNavLinks.removeClass('active');
				$(this).parents('li').addClass('active');
				$('.js_slider').slick('slickGoTo', index);
			});
		});

		// update navigation on swipe as well
		$(this.element).on('swipe', function(event, slick, direction){
			updateNavigation();
		});

    $(this.element).on('afterChange', function(event, slick, currentSlide){
      updateNavigation(currentSlide);
    });

    /**
		 * Pause and play
     */
    const playBtn = $('.js_scPlay');
    const pauseBtn = $('.js_scPause');

    if($('.slick-slide:not(.slick-cloned)').length > 1){
       playBtn.show();
       pauseBtn.show();
    }else {
      playBtn.hide();
      pauseBtn.hide();
    }

    pauseBtn.on('click', function() {
      $(this).removeClass('active');
      playBtn.addClass('active');
      $('.js_slider').slick('slickPause');
    });

    playBtn.on('click', function() {
      $(this).removeClass('active');
      pauseBtn.addClass('active');
      $('.js_slider').slick('slickPlay');
    });

    if ($('.js_slider-icon-container-1').length) {
        const random = 1 + Math.floor(Math.random() * 12);
        $('.js_slider-icon-container-'+random).removeClass('d-none');
    }

	}
}



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/Webslider.js